import { axios } from "utils";

import { PUBLIC_METHODS_URL as endpoint } from "consts";

// needed for admin

export const getMethods = async (data) => axios.get(`${endpoint}/`, { data });
